angular.module("screensApp")
    .service('AutoCaptureService', function() {
        // Konstanta pre animovanie progressbaru pri foteni dokumentu pre atribut "values" v elemente <animate attributeName="stroke-dasharray">
        this.documentProgressAnimationValues = '0 2460; 460 2000; 1060 1400; 1530 900; 2000 460; 100 2360';
        // Konstanta pre animovanie progressbaru pri selfie pre atribut "values" v elemente <animate attributeName="stroke-dasharray">
        this.selfieProgressAnimationValues = '0 150;42 150;42 150;42 150';

        this.documentCaptureStates = {
            idFront: 'idFront',
            idBack: 'idBack'
        };

        this.faceCaptureStates = {
            biometry: 'biometry',               // Uses during Login by biometry
            selfie: 'selfie',                   // Uses during Onboarding by biometry
            privateAccess: 'privateAccess'  // Uses when player is loggen in and requests user data
        };

        this.captureStatesFromNative = {
            idFrontSuccess: 'idFrontSuccess',
            idBackSuccess: 'idBackSuccess',
            selfieSuccess: 'selfieSuccess',

            idFrontFailed: 'idFrontFailed',
            idBackFailed: 'idBackFailed',
            selfieFailed: 'selfieFailed',

            pause: 'pause',
            canceled: 'canceled',
            init: 'init'
        }

        this.autoCaptureState = false;

        this.setAutoCaptureState = function(state) {
            // Check for valid states
            if (![false, ...Object.values(this.documentCaptureStates), ...Object.values(this.faceCaptureStates)].includes(state)) {
                return false;
            }
            this.autoCaptureState = state;
        }

        this.getAutoCaptureState = function() {
            return this.autoCaptureState;
        }

        // Blob of jpg to base64
        this.blobToImage = function(blob, acState, deleteFormatPrefix) {
            return new Promise((resolve, reject) => {
              try {
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  // Sluzba central-sportbox potrebuje base64 bez prefixu "data:image/jpeg;base64,"
                  resolve(deleteFormatPrefix ? reader.result.split(",")[1] : reader.result);
                };
                reader.onerror = (error) => {
                  $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: blobToImage() autoCaptureState: ' + acState + ' FileReader error: ' + error);
                  reject(error);
                };
              } catch (error) {
                $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: blobToImage() autoCaptureState: ' + acState + ' error: ' + error);
                reject(error);
              }
            });
        }

        // Funkcia ktora na zaklade autoCaptureState vrati boolean hodnotu ci prebieha onboarding
        // Vsetky autoCaptureState stavy: idFront, idBack, biometry, selfie, privateAccess, false
        // idFront, idBack, selfie stavy znamenaju, ze prebieha onboarding
        this.isOnboardingInProgress = function() {
            return [...Object.values(this.documentCaptureStates), this.faceCaptureStates.selfie].includes(this.getAutoCaptureState());
        }
    })

    .service('BiometryService', function($timeout) {
        // Timeout promise for hiding biometry login UI during logging by face
        var biometryTimeoutPromise = false;
        // Pause login after face capture/captures
        var faceCaptureBlock = false;
        // Timestamp of pressing the login button
        var biometryLoginBtnTimeStamp = 0;
        // Count of face captures
        var biometryCaptureCount = 0;

        this.setBiometryTimeout = function(callback, delay) {
            biometryTimeoutPromise = $timeout(callback, delay);
            return biometryTimeoutPromise;
        }

        this.clearBiometryTimeout = function() {
            $timeout.cancel(biometryTimeoutPromise);
            delete biometryTimeoutPromise;
        }

        this.setBiometryPause = function(blockCapture) {
            faceCaptureBlock = blockCapture;
        }

        this.getBiometryPause = function() {
            return faceCaptureBlock;
        }

        this.setBiometryLoginBtnTimeStamp = function(timeStamp) {
            biometryLoginBtnTimeStamp = timeStamp;
        }

        this.getBiometryLoginBtnTimeStamp = function() {
            return biometryLoginBtnTimeStamp;
        }

        this.setBiometryCaptureCount = function(captureCount) {
            biometryCaptureCount = captureCount;
            return biometryCaptureCount;
        }

        this.getBiometryCaptureCount = function() {
            return biometryCaptureCount;
        }

        this.setRequestorPlayerID = function(playerID) {
            if (typeof playerID === "number") {
                this.playerID = playerID;
                return this.playerID;
            }
            return false;
        }

        this.getRequestorPlayerID = function() {
            return this.playerID;
        }

        this.clearRequestorPlayerID = function() {
            this.playerID = 0;
            return true;
        }
    })

    .service('OnboardingService', function($timeout) {
        // Timeout promise for hiding document onboarding UI during logging by face
        var documentTimeoutPromise = false;
        // Pause login after face capture/captures
        var documentCaptureBlock = false;

        this.setDocumentTimeout = function(callback, delay, clearTimeout) {
            if (clearTimeout) {
                this.clearDocumentTimeout();
            }
            documentTimeoutPromise = $timeout(callback, delay);
            return documentTimeoutPromise;
        }

        this.clearDocumentTimeout = function() {
            $timeout.cancel(documentTimeoutPromise);
            delete documentTimeoutPromise;
        }

        this.setDocumentPause = function(blockCapture) {
            if (!blockCapture) {
                document.dispatchEvent(
                    new CustomEvent("document-auto-capture:control", {
                    detail: { instruction: "continue-detection" }
                    })
                );
            }
            documentCaptureBlock = blockCapture;
        }

        this.getDocumentPause = function() {
            return documentCaptureBlock;
        }
    }
);


angular.module("screensApp").factory('VerificationService', function ($http, $q, $rootScope, $timeout) {

    const activeBiometricVerificationPromise = {};
    const TIMEOUT_MS = 30000;

    return {
        fetchBiometricVerificationStatusPrivate: function (selfieBase64, imageTimeStamp, requestorPlayerID) {

            // Zrušíme staré požiadavky
            this.cancelActiveRequests();

            // Canceler pre $http timeout
            var canceler = $q.defer();

            // Timeout po 30 sekundách, ktorý zruší request
            var timer = $timeout(function () {
                canceler.resolve('timeout');
            }, TIMEOUT_MS);

            var requestBody = {
                playerID: requestorPlayerID,
                selfieBase64: selfieBase64
            };

            var promise = $http.post(
                $rootScope.url.CentralSBURL + "sportbox/ac/player-selfie-verification",
                requestBody,
                {
                    timeout: canceler.promise
                }
            )
            .then(function (response) {
                response.data.requestorPlayerID = requestBody.playerID;
                return response.data;
            })
            .finally(function () {
                // Zrušíme timer (aby nebežal ďalej)
                $timeout.cancel(timer);

                // Odstránime z registrácie
                delete activeBiometricVerificationPromise[imageTimeStamp];
            });

            // Uložíme aktívny request
            activeBiometricVerificationPromise[imageTimeStamp] = {
                canceler,
                timer,
                promise
            };

            // Vraciame objekt
            return {
                id: imageTimeStamp,
                promise: promise,
                cancel: function () {
                    canceler.resolve('canceled');
                }
            };
        },

        cancelActiveRequests() {
            Object.keys(activeBiometricVerificationPromise).forEach(function (imageTimeStamp) {
                const entry = activeBiometricVerificationPromise[imageTimeStamp];

                entry.canceler.resolve('canceled');
                $timeout.cancel(entry.timer);

                delete activeBiometricVerificationPromise[imageTimeStamp];
            });
        }
    };
});
``

